"use client";

import { Building2, Plane } from "lucide-react";

export function WorkspaceWelcomeStep() {
  return (
    <div className="space-y-6">
      <div className="rounded-lg border bg-muted/30 p-6 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Plane className="h-6 w-6" />
        </div>
        <h3 className="text-lg font-semibold">Set up your travel agency workspace</h3>
        <p className="mt-2 text-sm text-muted-foreground">
          We&apos;ll collect your workspace identity, accounting currency, and
          default ledgers so you can start quoting and booking faster.
        </p>
      </div>

      <div className="rounded-lg border p-4 text-sm text-muted-foreground">
        <div className="mb-2 flex items-center gap-2 font-medium text-foreground">
          <Building2 className="h-4 w-4" />
          What we&apos;ll cover now
        </div>
        <ul className="space-y-1.5">
          <li>• Agency structure (single or multi-brand)</li>
          <li>• Workspace name, branding, and regional settings</li>
          <li>• Primary currency and default accounting ledgers</li>
        </ul>
        <p className="mt-3 text-xs">
          Brand setup, team invites, and integrations come in the next steps.
        </p>
      </div>
    </div>
  );
}
